// loading/actions.js

import { loadingInitialState } from "./loadingState";

export const makeLoadingActions = (set, get) => ({
  showLoading: (message = "Loading...") =>
    set((s) => ({
      loading: {
        isActive: true,
        message,
      },
    })),
  hideLoading: () =>
    set((s) => ({
      loading: { ...s.loading, isActive: false },
    })),
  resetLoading: () => set({ loading: loadingInitialState }),
});
